import React from 'react';
import { waveSvgs, waveBackgrounds, waveSvgHeights } from '../../data/waveSvgs';
import './WaveDivider.css';

function WaveDivider({ variant, size = 'default' }) {
  const svg = waveSvgs[variant];
  const bg = waveBackgrounds[variant];
  const height = waveSvgHeights[size] || waveSvgHeights.default;

  if (!svg) return null;

  return (
    <div
      className="wave-divider"
      style={{ background: bg }}
    >
      <div style={{ height: `${height}px` }}>
        {svg}
      </div>
    </div>
  );
}

export default WaveDivider;
